import React, { useState } from 'react';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Typography,
  Modal,
} from '@mui/material';
import {
  MoreVert,
  Share,
  WhatsApp,
  TrendingUp,
} from '@mui/icons-material';
import { NormalizedMessage } from '../../types/normalizedMessage';
import CreatePost from '../../pages/posts/create-post/CreatePostPage';

interface MessageActionsMenuProps {
  message: NormalizedMessage;
  isCurrentUser: boolean;
  senderWhatsApp?: string;
}

export const MessageActionsMenu: React.FC<MessageActionsMenuProps> = ({
  message,
  isCurrentUser,
  senderWhatsApp,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openOpportunityDialog, setOpenOpportunityDialog] = useState(false);
  const open = Boolean(anchorEl);


  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenOpportunityDialog = () => {
    setOpenOpportunityDialog(true);
    handleClose();
  };

  const handleCloseOpportunityDialog = () => {
    setOpenOpportunityDialog(false);
  };

  const handleShareWhatsApp = () => {
    const messageText = encodeURIComponent(
      `Mensaje desde Alien Realty: \n\n ${message.content}`
    );
    const whatsappUrl = `https://wa.me/?text=${messageText}`;
    window.open(whatsappUrl, '_blank');
    handleClose();
  };

  const handleGoToSenderWhatsApp = () => {
    console.log('Ir al WhatsApp del remitente:', message);
    if (senderWhatsApp) {
        if(!senderWhatsApp.includes("506")){

            senderWhatsApp = "506" + senderWhatsApp;
        }
      const messageText = encodeURIComponent(`Hola, saludos cordiales, me interesa el anuncio de esta propiedad, me podrías dar mas detalles por favor: \n\n ${message.content}`);
      const whatsappUrl = `https://wa.me/${senderWhatsApp.replace(/[^\d]/g, '')}?text=${messageText}`;
      window.open(whatsappUrl, '_blank');
    } else {
      alert('Número de WhatsApp no disponible para este usuario');
    }
    handleClose();
  };

  const handleConvertToOpportunity = () => {
    handleOpenOpportunityDialog();
    handleClose();
  };

  return (
    <>
      <Box
        className="message-actions"
        sx={{
          opacity: 0,
          transition: 'opacity 0.2s',
          display: 'flex',
          gap: 0.5,
        }}
      >
        <IconButton
          size="medium"
          sx={{ color: 'text.secondary' }}
          onClick={handleClick}
          aria-controls={open ? 'message-actions-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <MoreVert fontSize="medium" />
        </IconButton>
      </Box>

      <Menu
        id="message-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'message-actions-button',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          elevation: 8,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.15))',
            mt: 1.5,
            minWidth: 200,
            borderRadius: 2,
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              left: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
      >
        <MenuItem
          onClick={handleShareWhatsApp}
          sx={{
            py: 1.5,
            px: 2,
            '&:hover': {
              bgcolor: 'action.hover',
              '& .MuiListItemIcon-root': {
                color: '#25D366',
              },
            },
          }}
        >
          <ListItemIcon>
            <WhatsApp 
              sx={{ 
                color: '#25D366',
                fontSize: 22,
              }} 
            />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2" fontWeight={500}>
              Compartir por WhatsApp
            </Typography>
          </ListItemText>
        </MenuItem>

        {!isCurrentUser && (
          <MenuItem
            onClick={handleGoToSenderWhatsApp}
            sx={{
              py: 1.5,
              px: 2,
              '&:hover': {
                bgcolor: 'action.hover',
                '& .MuiListItemIcon-root': {
                  color: '#25D366',
                },
              },
            }}
          >
            <ListItemIcon>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <WhatsApp 
                  sx={{ 
                    color: '#25D366',
                    fontSize: 18,
                  }} 
                />
                <Share 
                  sx={{ 
                    color: '#25D366',
                    fontSize: 14,
                  }} 
                />
              </Box>
            </ListItemIcon>
            <ListItemText>
              <Typography variant="body2" fontWeight={500}>
                Chat con {message.senderProfile?.username || 'Usuario'}
              </Typography>
            </ListItemText>
          </MenuItem>
        )}

        <Divider sx={{ mx: 1 }} />

        <MenuItem
          onClick={handleConvertToOpportunity}
          sx={{
            py: 1.5,
            px: 2,
            '&:hover': {
              bgcolor: 'action.hover',
              '& .MuiListItemIcon-root': {
                color: 'primary.main',
              },
            },
          }}
        >
          <ListItemIcon>
            <TrendingUp 
              sx={{ 
                color: 'primary.main',
                fontSize: 22,
              }} 
            />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2" fontWeight={500}>
              Convertir en oportunidad
            </Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
     <Modal
     open={openOpportunityDialog}
     onClose={handleCloseOpportunityDialog}
   >
     <CreatePost isFromChannel={true} messageFromChannel={message.content} />
   </Modal>
   </>
  );
};